export const BUILD_VERSION = '1784045615';
